import { render, staticRenderFns } from "./coach-registration-certificate.vue?vue&type=template&id=474f0fc2&scoped=true&"
import script from "./coach-registration-certificate.vue?vue&type=script&lang=js&"
export * from "./coach-registration-certificate.vue?vue&type=script&lang=js&"
import style0 from "./coach-registration-certificate.vue?vue&type=style&index=0&id=474f0fc2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474f0fc2",
  null
  
)

export default component.exports